import debug from 'Helper/debugHelpers'
import * as time from 'Helper/timeHelpers'
import { put, select, fork } from 'redux-saga/effects'
import { delay } from 'Helper/customReduxEffects.js'
import * as authActions from 'actions/authActions'

export function * startClock() {
  yield put({
    type: 'START_CLOCK',
    running: true
  })
  // while running is true
  yield fork(function * () {
    while (yield select(state => state.clock.running)) {
      const lastTick = yield select(state => state.clock.lastTick)
      const newTime = new Date()
      const nextTick = newTime.getTime()
      const clock = time.format(newTime, true)
      if (lastTick != null && nextTick > lastTick + WAKE_FROM_SLEEP_TIMEOUT) {
        // if its been more than 10 seconds since the last tick we've probably
        // been sleeping
        const lost = nextTick - lastTick
        debug.log(
          'waking from sleep (lost ' + (lost / 1000).toFixed(2) + ' seconds)',
          debug.logLevels.HIGHLIGHT
        )
        if (yield select(state => state.auth.refreshToken)) {
          // try to do an immediate token refresh if we have a token since the token could be expiring
          yield put(authActions.doTokenRefresh())
        }
        // at any time
        let maxWaitCnt = 10 // make sure we cant get stuck in while
        while (!window.navigator.onLine && maxWaitCnt > 0) {
          // if the network is off line... try waiting until it comes online
          // before we do the token refresh
          yield delay(250)
          maxWaitCnt--
        }
      }
      yield put({
        type: 'UPDATE_TIME',
        clock,
        lastTick: nextTick
      })
      yield delay(1000)
    }
  })
}
